import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const addAppAdminTrainingTopicSlice = createApi(`AddAppAdminTrainingTopicSlice`, "POST");

const AddAppAdminTrainingTopicSlice = createSlice({
  name: 'AddAppAdminTrainingTopicSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addAppAdminTrainingTopicSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAppAdminTrainingTopicSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addAppAdminTrainingTopicSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default AddAppAdminTrainingTopicSlice.reducer;
